/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopPaceSchema = z.object({
  actualCost: z
    .string()
    .describe(
      'Sum of actual cost across the same top-level items included in expectedSpendToDate — a scoped counterpart to the top-level actualCost, so the two are comparable. Use this (not the top-level actualCost) alongside expectedSpendToDate/variance when displaying pace figures together, since the top-level actualCost may include items excluded here.',
    ),
  budgetedCost: z
    .string()
    .describe(
      'Sum of effective budget across the same top-level items included in expectedSpendToDate — a scoped counterpart to the top-level budgetedCost, for the same reason as actualCost.',
    ),
  expectedSpendToDate: z
    .string()
    .describe(
      "Sum, across whichever top-level items have complete pace data, of that item's effective budget times the elapsed percentage of its own planned schedule as of today. Items missing effective budget, actual-cost completeness, or valid planned dates are excluded rather than nulling the total — see itemsIncluded/itemsTotal for coverage.",
    ),
  itemsIncluded: z
    .int()
    .describe(
      "Number of the loop's top-level items included in this calculation (each needs an effective budget, known actual-cost completeness, and valid planned dates).",
    ),
  itemsTotal: z
    .int()
    .describe(
      'Total top-level items in the loop, for comparison against itemsIncluded to show pace coverage.',
    ),
  status: z
    .enum(['UNDER_PACE', 'OVER_PACE'])
    .describe(
      'UNDER_PACE when actual cost is no more than expectedSpendToDate, otherwise OVER_PACE.',
    ),
  variance: z
    .string()
    .describe(
      'expectedSpendToDate minus actualCost: positive is under pace, negative is over pace.',
    ),
});
